export default __webpack_public_path__ + "static/media/header.1c961a49.jpg";